import {h} from 'preact';
import {ReviewsApiContainer} from '@containers/CustomerReviews/api';
import invoke from 'lodash.invoke';
import Button from '@components/common/Button';
import Message from '@components/common/Message';

const DialogDeleteComment = ( props, context ) => {
    const {id} = props.submitData;
    const closeModal = () => invoke( context, 'onClose' );
    return (
        <ReviewsApiContainer render={( {updateReviewResponse: {mutation, result}} ) =>
            <div className="max-w-sm">
                <div className="button-bar mt-8">
                    <Button secondary onClick={closeModal}>No</Button>
                    <Button
                        loading={result.loading}
                        data-testid="test-deleteComment"
                        onClick={() =>
                            mutation( {
                                variables: {input: {id, comment: ''}}
                            } ).then( closeModal )
                        }>
                        Yes
                    </Button>
                </div>
                {result.error &&
                <Message fail>
                    There was an error while trying to delete this comment, please try again.
                </Message>
                }
            </div>
        }/>
    );
};

export default DialogDeleteComment;